export const API_ENDPOINTS = {
	// Auth
	AUTH_SIGNUP: '/auth/signup',
	AUTH_LOGIN: '/auth/login',
	AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
	AUTH_RESET_PASSWORD: '/auth/reset-password',
	AUTH_LOGOUT: '/auth/log-out',
	AUTH_VERIFY_OTP: '/auth/verify-otp',
	AUTH_SOCIAL_LOGIN: '/auth/social-login',
	AUTH_RESEND_OTP: '/auth/resend-otp',
	AUTH_VERIFY_ACCOUNT: '/auth/verify-account',
	AUTH_SEND_2FA: '/auth/resend-twoauth-otp',
	AUTH_VERIFY_2FA: '/auth/verify-twoauth-otp',
	GOOGLE_ACCESS_TOKEN: 'https://oauth2.googleapis.com/token',
	GET_LINKEDIN_CALLBACK: '/auth/linkedin/callback',
	AUTH_UPDATE_SOCIAL_DETAILS: '/auth/update-social-details',

	// User
	USER_DETAILS: '/users/details',
	STATIC_USER_DETAILS: '/users/static-user-detail',
	USER_UPDATE_PROFILE: '/users/update-profile',
	USER_PREFERENCES_FIELDS: '/users/preference-data-list',
	USER_PREFERENCES_SAVE: '/users/save-preference',
	USER_GET_PREFERENCES: '/users/get-preference',
	USER_CHANGE_PASSWORD: '/users/change-password',
	USER_DELETE_ACCOUNT: '/users/delete-account',
	USER_DEACTIVATE_ACCOUNT: '/users/deactivate-account',
	USER_CHANGE_2FA: '/users/set-twofa',
	USER_VERIFY_2FA: '/users/verify-twofa',
	USER_VERIFY_PROFILE_MOBILE: '/users/verify-phone-otp',
	USER_SEND_PROFILE_OTP: '/users/send-phone-otp',
	USER_DELETE_PROFILE_ELEMENT: '/users/delete-profile-elements',
	USER_GET_CONNECTION: '/users/get-connection',
	USER_SEND_CONNECTION_REQUEST: '/users/send-connection-request',
	USER_REMOVE_CONNECTION: '/users/remove-connection',
	USER_ACCEPT_CONNECTION: '/users/accept-connection-request',
	USER_GET_BLOCK_USER_LIST: '/users/get-block-user',
	USER_BLOCK_USER: '/users/block-user',
	USER_UNBLOCK_USER: '/users/unblock-user',
	USER_FOLLOWINGS: '/users/followings',
	USER_FOLLOWERS: '/users/followers',

	// Company
	COMPANY_DETAILS: '/company',
	COMPANY_UPDATE_PROFILE: '/company/profile/update',
	COMPANY_TALENT: '/company/talent',
	FOLLOW_COMPANY: '/company/follow',
	DELETE_ASSESSMENT: '/assessment',
	COMPANY_EMPLOYEE_LIST: '/company/employee/list',

	// Utils
	GET_LOCATIONS: '/util/location',
	GET_COUNTRY_LIST: '/util/get-country-list',
	GET_STATE_LIST: '/util/get-state-list',
	GET_CITY_LIST: '/util/get-city-list',
	GET_MEDIA_SIGN_URL: '/util/get-media-signurl',
	GET_COMPANY_SEARCH: '/company/search',
	GET_SKILLS_LIST: '/util/get-skills',
	GET_LANGUAGES_LIST: '/util/get-language',
	GET_INDUSTRIES_LIST: '/util/get-industries',
	GET_STATIC_PAGES: '/util/static-pages',
	CONTACT_US_FORM: '/util/contact-us',
	GET_MULTI_SEARCH_RESULT: '/util/multi-search',
	GET_FAQ: '/util/faq',
	REPORT_URL: '/util/report',
	GET_REPORT_REASONS: '/util/get-static-list',
	GET_HOME_SLIDER: '/util/get-home-sliders',
	PAGE_VISIT: '/util/page-visit',

	// Jobs
	GET_JOBS_DATA: '/job/post-data-list',
	GET_POPULAR_JOBS: '/job/home',
	GET_PREFERENCE_JOBS: '/job/preference-jobs',
	GET_JOB_LIST: '/job/list',
	JOB: '/job',
	JOB_FAVORITE: '/job/favourite',
	JOB_MARK_AS_FAVORITE: '/job/favourite',
	JOB_MARK_AS_UNFAVORITE: '/job/favourite',
	JOB_APPLY: '/job/apply',
	JOB_APPLIED: '/job/applied-jobs',
	JOB_LIST_FILTER: '/job/job-list-filter',
	JOB_SAVE_ALERT: '/job/job-alert',
	JOB_POSTED: '/job/posted',
	GET_JOB_DETAIL_EDIT: '/job/edit',
	JOB_UPDATE: '/job/update',
	GET_APPLICANTS_LIST: '/job/applied-candidates',
	GET_INACTIVE_JOB_LIST: '/job/inactive',
	GET_EXPIRED_JOB_LIST: '/job/expired',
	JOB_ACTIVE: '/job/active',
	HASHTAG_PROFILE: '/social-media/post-list',
	GET_JOB_AI_SUGGESTIONS: '/job/ai-suggestions',

	// Assessment
	GET_SEEKER_ASSESSMENT: '/assessment/view-result',
	GET_ASSESSMENTS: '/assessment/get-job-assessment',
	GET_ASSESSMENT_SAVE: '/assessment/save',
	SAVE_ASSESSMENT: '/assessment/add-assessment-question',

	// Hiring Board
	GET_HIRING_BOARD_LIST: '/company/hiring-board/list',
	CHANGE_HIRING_BOARD_STATUS: '/company/hiring-board/change-status',
	REJECT_CANDIDATE: '/company/hiring-board/reject-candidate',
	GET_SEEKER_FILTER_DATA: '/seeker/filter-data',

	// Post
	ADD_POST: '/social-media/post',
	POST_LIST: '/social-media/post-list',
	STATIC_POST_LIST: '/social-media/static-post-list',
	HASHTAG_LIST: '/social-media/hashtag',
	CHECK_HASHTAGS: '/social-media/hashtag/check',
	MENTIONS_USERS_LIST: '/social-media/post/suggestion-list',
	POST_LIKE: '/social-media/post-like',
	POST_LIKED: '/social-media/post-like/list',
	Add_COMMENT: '/social-media/comment',
	COMMENT_REPLIES: '/social-media/comment/replies',
	LIKE_COMMENT: '/social-media/comment/like',
	DELETE_COMMENT: '/social-media/comment',
	FOLLOW_HASHTAG: '/social-media/hashtag/follow',
	STATIC_FOLLOW_HASHTAG: '/social-media/hashtag/static-follow-list',
	SHARE_POST_USERS: '/social-media/post/share-list',
	SHARE_POST: '/social-media/post/share',
	USER_ACTIVITY: '/users/activity-logs',

	// Story
	STORY: '/story',
	STATIC_CREATE_STORY: '/story/static-create-story',
	STORY_LIST: '/story/list',
	STATIC_STORY_LIST: '/story/static-story-list',
	STORY_VIEWERS: '/story/views',
	STORY_VIEW: '/story/view',

	// ResumeBuilder
	RESUME_TEMPLATES: '/resume/list',
	RESUME_TEMPLATE_DETAILS: '/resume/seeker',
	RESUME_TEMPLATE_DETAILS_MOBILE: '/resume/seeker/template-data',
	RESUME_TEMPLATE_DOWNLOAD: '/resume/download',
	RESUME_TEMPLATE_DOWNLOAD_MOBILE: '/resume/seeker/download-data',
	RESUME_TEMPLATE_SAVE: '/resume/seeker',
	RESUME_TEMPLATE_DATA_LIST: '/resume/data-list',

	// Meeting
	GET_MEETING_TIME_AVAILABILITY: '/util/get-static-list',
	COMPANY_MEETING_LIST: '/company/meeting/list',
	COMPANY_GET_SEEKER_AVAILABILITY: '/company/meeting/seeker-availability',
	SEEKER_MEETING_LIST: '/seeker/meeting/list',
	SAVE_SEEKER_AVAILABILITY: '/seeker/meeting/save-availability',
	GET_SEEKER_AVAILABILITY: '/seeker/meeting/get-availability',
	CANCEL_SEEKER_MEETING: '/seeker/meeting/cancel',
	CHANGE_MEETING_STATUS: '/company/meeting/change-status',
	SCHEDULE_INTERVIEW_WITH_SEEKER: '/company/meeting/schedule-interview',
	GET_GOOGLE_AUTH_TOKEN: '/company/meeting/save-google-token',
	GET_GOOGLE_AUTH_URL: '/company/meeting/get-google-auth-url',
	GET_CHECK_GOOGLE_TOKEN: '/company/meeting/check-google-token',

	// Chat
	GET_CHAT_USERS: '/chat',
	GET_CHAT_DETAILS: '/chat/details',

	// ZegoCloud Token
	GET_ZEGO_TOKEN: '/chat/call-token',

	// Blogs
	GET_BLOGS: '/blogs',
	GET_BLOG_CATEGORIES: '/categories',

	// Advertisement
	GET_ADVERTISEMENT: '/advertisement/list',
	ADVERTISEMENT: '/advertisement',
	ADVERTISEMENT_PRICE: '/advertisement/price_per_day',

	// Notification
	NOTIFICATION_LIST: '/notifications/list',
	NOTIFICATION_READ: '/notifications/mark-all-read',
	NOTIFICATION_READ_BY_ID: '/notifications/mark-read',

	// Subscription
	SUBSCRIPTION_PLANS: '/plans/list',
	PAYMENT_URL: '/stripe/create-payment-link',
	CHECK_SUBSCRIPTION: '/plans/purchase/check-subscription',
	CHECK_PURCHASE_STATUS: '/stripe/check-purchase-status',
	PURCHASE_HISTORY: '/plans/purchase/history',
	CANCEL_SUBSCRIPTION: '/stripe/cancel-subscription',
};
